<form (submit.prevent)="onSubmit()">
  <ui-simple-dialog-layout (clickCancel)="clickCancel.emit()" class="w-full block">
    <span slot="title">{{ 'cockpit.documents.editDialog.title' | transloco }}</span>
    <div class="flex flex-col gap-6">
      <ui-input-label>
        {{ 'cockpit.documents.editDialog.nameLabel' | transloco }}
        <ui-input-simple [formField]="form.filename" />
        <app-field-errors slot="bottom" [fieldState]="form.filename()" />
      </ui-input-label>
      <ui-input-label>
        {{ 'cockpit.documents.editDialog.categoryLabel' | transloco }}
        <ui-select [formField]="form.fileType">
          <option
            value="SUPPLIER_CONTRACT"
            [selected]="form.fileType().value() === 'SUPPLIER_CONTRACT'"
          >
            {{ 'cockpit.documents.filterForm.fileType.supplierContract' | transloco }}
          </option>
          <option
            value="SUPPLIER_INVOICE"
            [selected]="form.fileType().value() === 'SUPPLIER_INVOICE'"
          >
            {{ 'cockpit.documents.filterForm.fileType.supplierInvoice' | transloco }}
          </option>
          <option
            value="ORGANIZATION_PROFILE"
            [selected]="form.fileType().value() === 'ORGANIZATION_PROFILE'"
          >
            {{ 'cockpit.documents.filterForm.fileType.organizationProfile' | transloco }}
          </option>
          <option
            value="LMA_LOCATION_ANALYSIS"
            [selected]="form.fileType().value() === 'LMA_LOCATION_ANALYSIS'"
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaLocationAnalysis' | transloco }}
          </option>
          <option value="LMA_OTHER" [selected]="form.fileType().value() === 'LMA_OTHER'">
            {{ 'cockpit.documents.filterForm.fileType.lmaOther' | transloco }}
          </option>
          <option
            value="LMA_BATTERY_SIMULATION"
            [selected]="form.fileType().value() === 'LMA_BATTERY_SIMULATION'"
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaBatterySimulation' | transloco }}
          </option>
          <option
            value="LMA_GRID_USAGE_OPTIMIZATION"
            [selected]="form.fileType().value() === 'LMA_GRID_USAGE_OPTIMIZATION'"
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaGridUsageOptimization' | transloco }}
          </option>
          <option
            value="LMA_LOAD_SIMULATION"
            [selected]="form.fileType().value() === 'LMA_LOAD_SIMULATION'"
          >
            {{ 'cockpit.documents.filterForm.fileType.lmaLoadSimulation' | transloco }}
          </option>
          <option value="UNKNOWN" [selected]="form.fileType().value() === 'UNKNOWN'">
            {{ 'cockpit.documents.filterForm.fileType.unknown' | transloco }}
          </option>
        </ui-select>
        <app-field-errors slot="bottom" [fieldState]="form.fileType()" />
      </ui-input-label>
    </div>
    @if (editError()) {
      <ui-input-error slot="error">
        {{ 'cockpit.documents.editDialog.errorMessage' | transloco }}
      </ui-input-error>
    }
    <ui-button
      slot="footer"
      mode="outlined"
      (click)="clickCancel.emit()"
      expand="full"
      type="button"
    >
      {{ 'cockpit.documents.editDialog.closeButton' | transloco }}
    </ui-button>
    <ui-button
      slot="footer"
      type="submit"
      [disabled]="isSubmitDisabled()"
      [loading]="isEditLoading()"
      expand="full"
    >
      {{ 'cockpit.documents.editDialog.saveButton' | transloco }}
    </ui-button>
  </ui-simple-dialog-layout>
</form>
